document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth < 1024) return;

  const fullMenuUl = document.querySelector('.full-menu ul.thb-full-menu');
  if (!fullMenuUl) return;

  const targetNames = ['store', 'about'];
  const targetItems = Array.from(fullMenuUl.querySelectorAll('li')).filter(li => {
    const a = li.querySelector('a');
    return a && targetNames.includes(a.textContent.trim().toLowerCase());
  });

  if (targetItems.length === 0) return;

  const newUl = document.createElement('ul');
  newUl.classList.add('thb-full-menu');

  targetItems.forEach(li => newUl.appendChild(li));

  const target = document.querySelector('.thb-secondary-area.thb-header-right');
  if (!target) return;

  target.prepend(newUl);



  const currentPath = window.location.pathname.replace(/\/$/, '');
  const allParentItems = document.querySelectorAll('.menu-item-has-children');

  function closeAll(exceptItem) {
    allParentItems.forEach(li => {
      if (li === exceptItem) return;
      li.classList.remove('active');
      const sm = li.querySelector('.sub-menu');
      if (sm) {
        sm.style.visibility = '';
        sm.style.opacity = '';
      }
    });
  }

  function openItem(item) {
    const sm = item.querySelector('.sub-menu');
    if (!sm) return;
    item.classList.add('active');
    sm.style.visibility = 'visible';
    sm.style.opacity = '1';
  }

  // หาตัวที่ควร active ตอนโหลดหน้า (ตัวเดียวเท่านั้น)
  let initialActiveItem = null;

  allParentItems.forEach(item => {
    const subMenu = item.querySelector('.sub-menu');

    const parentLink = item.querySelector(':scope > a');
    const parentPath = parentLink ? parentLink.getAttribute('href').replace(/\/$/, '') : null;
    const parentMatches = parentPath === currentPath;

    let childMatches = false;
    if (subMenu) {
      subMenu.querySelectorAll('a').forEach(a => {
        const linkPath = a.getAttribute('href').replace(/\/$/, '');
        if (linkPath === currentPath) childMatches = true;
      });
    }

    if (parentMatches || childMatches) {
      initialActiveItem = item;
    }
  });

  // เคลียร์ class active เดิมที่ theme อาจติดมาให้ผิดตัว แล้วเปิดแค่ตัวที่ถูกต้องตัวเดียว
  closeAll(null);
  if (initialActiveItem) {
    openItem(initialActiveItem);
  }

  allParentItems.forEach(item => {
    item.addEventListener('click', function () {
      if (window.innerWidth < 1024) return;

      closeAll(this);
      openItem(this);
      // ไม่ preventDefault -> คลิกแล้วไปตาม href ของ <a> ตามปกติ
    });
  });

});

// document.addEventListener('DOMContentLoaded', function () {
//   const menuItems = document.querySelectorAll(
//     '.thb-full-menu > li.menu-item-has-children'
//   );

//   menuItems.forEach((item) => {
//     const sub = item.querySelector('.sub-menu');
//     if (sub) {
//       sub.style.display = 'none';
//       sub.style.visibility = 'hidden';
//       sub.style.opacity = '0';
//     }
//   });

//   function showSubMenu(item) {
//     menuItems.forEach((el) => {
//       el.classList.remove('is-active');
//       const sub = el.querySelector('.sub-menu');
//       if (sub) {
//         sub.style.display = 'none';
//         sub.style.visibility = 'hidden';
//         sub.style.opacity = '0';
//       }
//     });

//     item.classList.add('is-active');
//     const activeSub = item.querySelector('.sub-menu');
//     if (activeSub) {
//       activeSub.style.display = 'block';
//       activeSub.style.visibility = 'visible';
//       activeSub.style.opacity = '1';
//     }
//   }

//   if (menuItems.length > 0) {
//     showSubMenu(menuItems[0]);
//   }

//   menuItems.forEach((item) => {
//     item.addEventListener('mouseenter', function () {
//       showSubMenu(this);
//     });

//     item.addEventListener('click', function (e) {
//       const link = item.querySelector(':scope > a');
//       if (link && link.getAttribute('href') === '#') {
//         e.preventDefault();
//       }
//       showSubMenu(this);
//     });
//   });
// });